<template>
  <SalesWizard />
</template>

<script setup>
import SalesWizard from './Purchase/SalesWizard.vue'
</script>

<style scoped>
/* Styles are now in the individual components */
</style>
